const en = {
  // 公共
  common: {
    copyright: 'Solestage property in copyright',
    create: 'Create',
    edit: 'Edit',
    delete: 'Delete',
    view: 'View',
    export: 'Export',
    warning: 'warning',
    save: 'OK',
    error: 'error',
    success: 'success',
    emptyMsg: 'Not empty!',
    createdAt: 'Created At',
    updatedAt: 'Updated At',
    finishTime: 'Finish Time',
    back: 'back',
    email: 'email',
    confirm: 'confirm',
    cancel: 'cancel',
    notEmpty: 'not nullable',
    notAppear: 'If it does not appear in your main mailbox, please check your spam and promotions folders',
    notReceived: 'did not receive mail?',
    send: 'send',
    wait: 'Please wait 30 seconds for the email to arrive before requesting another link',
    resend: 'resend',
    accountSettings: 'Account Settings',
    logOut: 'Log Out',
    logOutMsg: 'Are you sure you want to log out?',
    updateUserSuccess: 'The user information has been updated',
    saveUserFail: 'Saving failed. Please try again later',
    saveUserValidate: 'Please check the input',
    nickName: 'Nick Name',
    username: 'Account',
    usernameCheck: 'Account format error',
    password: 'Enter Password',
    passwordToolTips: 'Please enter your old password',
    newPassword: 'New Password',
    newPasswordTooltip: 'Please enter your new password',
    againPassword: 'Confirm Password',
    againPasswordTooltip: 'Please enter the new password again',
    checkFomart: 'The format is incorrect',
    noPassword: 'Your password is incorrect',
    failChangePassword: 'Failed to change password!',
    inconformity: 'The two passwords are different!',
    identical: 'The new password is the same as the old password!',
    againLogin: 'Please log in again.',
    defaultSet: 'Basic setup',
    passwordSet: 'Reset the password',
    passwordRule: 'The password must contain at least six characters, including two types of letters and numbers',
    networkError: 'Network Error',
    tryagain: 'Please try again',
    deleteSuccess: 'Successfully delete!',
    correctNum: 'Please enter the correct number',
    getZero: 'Please enter a number greater than 0',
    abnormalOperation: 'Abnormal operation',
    waitData: 'Loading data, please wait',
    createSuccess: 'Successfully create!',
    noNewsYet: 'No news yet'
  },
  // 菜单管理menu
  menu: {
    home: 'Home',
    storeManagement: 'Store Management',
    shelvesManagement: 'Shelves Management',
    store: 'Store',
    shelves: 'Shelves',
    cargoSpace: 'Cargo Space',
    userManagement: 'User Management',
    accountManagement: 'Account Management',
    supplierManagement: 'Supplier Management',
    supplier: 'Supplier',
    supplierAudit: 'Supplier Audit',
    appUser: 'APP User',
    userRole: 'Role Management',
    settings: 'Settings',
    commodityLibrary: 'Commodity Library',
    category: 'Category',
    brand: 'Brand',
    series: 'Series',
    commodity: 'Commodity',
    orderManagement: 'Order Management',
    identificationOrder: 'Identification Order',
    aiIdentification: 'AI Identification',
    onlineIdentification: 'Online Identification',
    marketing: 'Marketing',
    feedback: 'Feedback'
  },
  // 用户管理模块
  accountManagement: { // 账号管理
    pageTitle: 'Account ManageMent',
    tableTitle: 'Account List',
    create: 'Create',
    nickName: 'Nick Name',
    userRole: 'User Role',
    name: 'Name',
    email: 'Email',
    accountStatus: 'Account Status',
    disabled: 'Disabled',
    enabled: 'Enabled',
    password: 'Password',
    passwordAgain: 'Confirm Password',
    reset: 'ResetPassword',
    category: 'category',
    passwordDiff: 'The two input passwords are inconsistent!',
    enableMsg: 'Do you want to enable this user account?',
    disableMsg: 'Do you want to disable this user account?',
    disSuccessMsg: 'The user account has been successfully disabled!',
    enSuccessMsg: 'The user account has been successfully enabled!',
    createTitle: 'Created Account',
    editTitle: 'Edit Account',
    createAccountSuccess: 'Account Created successfully!',
    createAccountFail: 'Account creation succeeded Account creation failed, please try again later!',
    eidtAccountSuccess: 'Account modification succeeded！',
    eidtAccountFail: 'Account modification failed. Please try again later！',
    hasUser: 'This role contains users and cannot be deleted.',
    resetSuccess: 'Password reset succeeded!',
    resetFail: 'Password reset succeeded Password reset failed, please try again later!',
    alreadyExist: 'The email account already exists!'
  },
  supManagement: { // 供应商管理
    pageTitle: 'Supperlier Management',
    tableTitle: 'Supperlier List',
    nickName: 'Nick Name',
    email: 'Email',
    phone: 'Phone',
    account: 'Account',
    address: 'Address',
    accountStatus: 'Account Status',
    disabled: 'Disabled',
    enabled: 'Enabled',
    enableMsg: 'Do you want to enable this supplier account?',
    disableMsg: 'Do you want to disable this supplier account?',
    disSuccessMsg: 'The supplier account has been successfully disabled!',
    enSuccessMsg: 'The supplier account has been successfully enabled!'
  },
  supplierAudit: { // 供应商注册审核
    pageTitle: 'Supperlier Audit',
    tableTitle: 'Apply Lisy',
    email: 'Email',
    shoeCount: 'Number',
    monthlyNo: 'Monthly No',
    monthlySales: 'Monthly Sales',
    mainSalesPlateforms: 'Main Sales Plateforms',
    replenish: 'Replenish',
    status: 'Status',
    pass: 'Pass',
    unpass: 'Unpass',
    passMsg: 'Do you want to apply through this supplier account?',
    successMsg: 'Audit Success！',
    unpassTitle: 'user registration audit',
    cause: 'the reason for refusal',
    placeholder: 'Please enter the reason for rejection',
    existed: 'Existed User'
  },
  appUser: { // app用户
    pageTitle: 'APP User',
    tableTitle: 'List Of Users',
    avatar: 'Avatar',
    nickName: 'Nick Name',
    email: 'Email',
    sex: 'Sex',
    userInfo: 'Basic information',
    signature: 'Signature',
    balance: 'Balance',
    detailHeader: 'User Detail',
    nickNameDetail: 'Nick Name：',
    emailDetail: 'Email：',
    sexDetail: 'Sex：',
    signatureDetail: 'Signature：',
    walletDetail: 'Wallet：',
    walletRecord: 'Balance of payments records'
  },
  walletDetails: { // 钱包明细
    pageTitle: 'The wallet details',
    tableTitle: 'Balance of payments records',
    type: 'Type',
    identify: 'Identify',
    account: 'Account',
    balance: 'Balance'
  },
  login: { // 登录
    name: 'SOLESTAGE MANAGEMENT PLATFORM',
    welcome: 'Hi,welcome to this system',
    invalid: 'Invalid Email',
    title: 'Login',
    password: 'password',
    forget: 'Forget Password?',
    login: 'Login',
    emailSendError: 'Email Send Error',
    emailCD: 'Please wait for a minute',
    signup: 'Signup Supplier',
    fill: 'Please fill in the account password',
    fail: 'Login Failed',
    errorPassword: 'Account or password incorrect',
    disable: 'This account has been disabled by the administrator!'
  },
  forget: { // 忘记密码
    title: 'Forget Password',
    tooltip: 'Enter the email you registered with to recover your password',
    sent: 'We have sent you an email with a link to reset your password',
    resendAsk: 'Do you need us to resend the link?',
    invalidEmail: 'Invalid Email',
    disabledEmail: 'Disabled Email',
    disable: 'This account has been disabled by the administrator!',
    toSignup: 'Please go to the registration interface to register',
    subject: 'Solestage reset password',
    emailInfo: {
      title: 'Reset Password',
      msg: 'We received a request to reset our password. Click the button below and you\'re ready to reset.',
      btn: 'reset password',
      msg2: 'If you received this email in error, please ignore this email. If you believe someone else is using your account without your consent, please contact us'
    }
  },
  signup: { // 供应商注册
    title: 'Sign Up',
    accountExisted: 'Already have an account ?',
    login: 'Login',
    signup: 'Signup',
    invalid: 'Invalid Email',
    existEmail: 'Email already exists',
    toLogin: 'Please go to login',
    haveSent: 'We have sent you an email, please continue to complete the registration process',
    ask: 'Do you need us to resend the link?',
    subject: 'solestage supplier signup',
    disabledEmail: 'Disabled Email',
    disable: 'This account has been disabled by the administrator!',
    emailInfo: {
      title: 'Supplier Sign Up',
      msg: ' We received a request to register an account. Click the button below and you are ready to register.',
      btn: 'sign up',
      msg2: 'If you received this email in error, please ignore this email.If you believe someone else is using your account without your consent, please contact us'
    }
  },
  userRole: { // 用户角色
    pageTitle: 'Role Management',
    tableTitle: 'The role list',
    roleName: 'Role Name',
    authorization: 'Aauthorizationsuthor',
    createTitle: 'Create the role',
    editTitle: 'Edit the role',
    createSuccess: 'Creating a successful！',
    createFail: 'Creation failed. Please try again later！',
    editSuccess: 'Modify successfully！',
    editFail: 'The modification failed. Please try again later！',
    deleteConfirm: 'Are you sure you want to delete this role?',
    deleteSuccess: 'Successfully delete',
    hasUser: 'This role contains users and cannot be deleted.'
  },
  permission: { // 权限
    pageTitle: 'Authorization',
    title: 'Functional Authority',
    introduce: 'Function rights Set the function operation, application management, and background management rights of a role',
    checkall: 'Check All',
    save: 'OK',
    saveMsg: 'Are you sure you want to modify the current role permissions?',
    saveSuccess: 'Modify successfully!',
    saveFail: 'Modification failed, please try again later!'
  },
  store: { // 仓库管理
    pageTitle: 'Store Management',
    tableTitle: 'Store List',
    name: 'Store Name',
    user: 'Contact',
    contact: 'Contact Details',
    location: 'Store Location',
    createdAt: 'created At',
    createTitle: 'Create Store',
    createStoreSuccess: 'Store created successfully!',
    createStoreFail: 'Store created failed!',
    storeNameExisted: 'Store name existed!',
    reviseStoreName: 'Please revise store name',
    editTitle: 'Edit Store',
    editSuccess: 'Store information has been modified',
    deleteTitle: 'Delete Store',
    deleteStore: 'Are you sure you want to delete this repository?',
    deleteFailed: 'Delete Failed',
    existShelf: 'Shelves under Store',
    deleteSuccess: 'Store has been deleted'
  },

  shelves: { // 货位管理
    storehouse: 'Store',
    pageTitle: 'Shelves Management',
    tableTitle: 'Shelves List',
    createTitle: 'Create Shelves',
    editShelves: 'Edit Shelves',
    numbering: 'Shelf Numbering',
    cargoRows: 'Cargo Rows',
    singleRow: 'Single Row Cargo Space',
    totalNumber: 'Total Cargo Space',
    earlyWarning: 'Warning Value',
    occupied: 'Occupied Space',
    remaining: 'Remind Space',
    remark: 'Remark',
    createdAt: 'Created At',
    createShelfSuccess: 'Shelf create successfully',
    editShelfSuccess: 'Shelf information has been modified',
    existedShelf: 'Shelf number already exists',
    reviseNumbering: 'Please modify the shelf number'
  },
  commodityLibrary: {
    pageTitle: 'Category Management',
    editTitle: 'Modify the category',
    viewTitle: 'View category',
    tableTitle: 'List Vies',
    name: 'Category',
    nameEn: 'Category',
    id: 'ID',
    brandNum: 'Brand Number',
    seriesNum: 'Series Number',
    status: 'Status',
    createTitle: 'The new category',
    commQuality: 'Assaying the fineness of goods',
    packaging: 'Packaging quality',
    categoryImg: 'Category Image',
    categoryIcon: 'Category Icon',
    canVerify: 'Identify state',
    can: 'Support to identify',
    noVer: 'Authentication is not supported',
    canAI: 'AI identification',
    canOnLine: 'Online identification',
    categoryImgToolTips: 'The icon picture is used to display the picture of the identified category on the APP identification page.  You are advised to upload a 1:1 PNG file. ',
    categoryIconToolTips: 'It is used to display ICONS of discriminant categories in APP identification page.  You are advised to upload a 1:1 PNG file. ',
    size: 'Size',
    createCategorySuccess: 'Category created successfully!',
    createCategoryFail: 'Category created successfully! Category creation failed, please try again later!',
    editCategorySuccess: 'Category modification successful!',
    editCategoryFail: 'Category modification successful! Category modification failed, please try again later!',
    deleteConfirm: 'Do you want to delete this category?',
    hasUser: 'Associated brand under this category, can not be deleted!',
    sizeTitle: 'Size',
    editSizeSuccess: 'Edit succeeded!',
    editSizeFail: 'Edit failed, please try again later!',
    ai: 'AI（$）:',
    standard: 'Standard（$）:',
    topspeed: 'Extremely Fast（$）:',
    editPrice: 'Edit Price'
  },
  brand: { // 品牌
    pageTitle: 'Brand Management',
    tableTitle: 'Brand List',
    parentNode: 'Category',
    name: 'Brand Name',
    nameEn: 'Brand Name',
    categoryImg: 'Brand Image',
    createTitle: 'The new brand',
    editTitle: 'Edit the brand',
    identifyPageTitle: 'Identification Points',
    seriesNum: 'Series number',
    isAIIdentification: 'Support for AI authentication',
    noIsAIIdentification: 'AI authentication is not supported',
    idenInfo: 'Identity Information',
    hasSeries: 'This brand contains series and cannot be deleted!',
    hasProduct: 'This brand contains product and cannot be deleted!',
    deleteConfirm: 'Do you want to delete the brand?',
    sizeTitle: 'Size conversion',
    point: {
      name: 'Points Name',
      nameEn: 'Points Name',
      identityImg: 'Pictures',
      scopeImg: 'Coverage',
      describe: 'Describe',
      describeEn: 'Describe',
      createTitle: 'New Identification Points',
      editTitle: 'Edit discriminant point',
      createCategorySuccess: 'Authentication point created successfully!',
      createCategoryFail: 'Authentication point creation failed, please try again later!',
      hasPoint: 'The identification site already exists!',
      editCategorySuccess: 'Modified identification point succeeded!',
      editCategoryFail: 'Failed to modify the authentication point, please try again later!',
      deleteConfirm: 'Do you want to remove this authentication point?'
    },
    detail: {

    },
    hasUser: 'Associated brand under this category, can not be deleted!'
  },
  series: { // 系列
    pageTitle: 'Series Management',
    tableTitle: 'Series List',
    parentNode: 'Category',
    name: 'Series Name',
    nameEn: 'Series Name',
    categoryImg: 'Series Image',
    createTitle: 'The new series',
    isAIIdentification: 'Support for AI authentication',
    noIsAIIdentification: 'AI authentication is not supported',
    identifyPageTitle: 'Identification Points',
    deleteConfirm: 'Whether to delete the series?',
    editTitle: 'Edit the series',
    point: {
      name: 'Points Name',
      nameEn: 'Points Name',
      identityImg: 'Pictures',
      scopeImg: 'Coverage',
      describe: 'Describe',
      describeEn: 'Describe',
      createTitle: 'New Identification Points'
    },
    hasUser: 'Associated brand under this category, can not be deleted!',
    isPopular: 'Whether it is a popular brand'
  },
  cargoSpace: { // 货位管理
    pageTitle: 'Cargo Space Management',
    tableTitle: 'Cargo Space List',
    storehouse: 'Store',
    shelves: 'Shelf Numbering',
    queue: 'Cargo Row Numbering',
    slotNumber: 'Cargo Space Numbering',
    stock: 'Inventory quantity',
    createdAt: 'Created At',
    qrcodeLog: 'print barcode',
    qrcodeLogMul: 'Batch Print Barcodes',
    cargoStock: 'Slot inventory',
    print: 'print',
    emptySelected: 'Please select the data to be printed',
    shelf: 'shelf',
    row: 'row',
    space: 'space',
    serial: 'serial',
    taste: 'taste',
    brand: 'brand',
    series: 'series',
    name: 'name',
    pid: 'PID'
  },
  product: { // 商品管理
    pageTitle: 'Commodities Management',
    tableTitle: 'Commodities List',
    images: 'Image',
    name: 'Name',
    nameCn: 'Name（Cn）：',
    nameEn: 'Name（En）：',
    style: 'Section number：',
    taste: 'Category',
    brand: 'Brand',
    quantity: 'Quantity',
    color: 'Color',
    colorCn: 'Color (Cn)：',
    colorEn: 'Color (En)：',
    audience: 'Audience',
    weight: 'Weight(Lbs)：',
    createTitle: 'Create Commodity',
    editTitle: 'Edit Commodity',
    viewTitle: 'View Commodity',
    deleteTitle: 'Delete Commodity',
    size: 'size',
    existedStyle: 'Existed Style',
    duplicateBarcode: 'Duplicate Barcode',
    describe: 'Describe（CN）：',
    describeEn: 'Describe（EN）：',
    releaseDate: 'Release Date',
    unisex: 'unisex',
    men: 'men',
    women: 'women',
    primarySchool: 'primary school',
    preschool: 'preschool',
    children: 'children',
    baby: 'baby'
  },
  aiIdentification: { // AI鉴别
    pageTitle: 'AI Identification',
    tableTitle: 'Order List',
    orderNo: 'Order Number',
    status: 'Order Status',
    result: 'Results',
    identifyCategory: 'Identify Category',
    identifyBrand: 'Identify Brand:',
    identifySeries: 'Identify Series',
    idenInfo: 'Identity Information',
    remark: 'Remark',
    theRating: 'The Rating',
    comments: 'Comments',
    score: 'Grade'
  },
  identification: { // 在线鉴别
    pageTitle: 'Identification',
    tableTitle: 'Order List',
    myIdentification: 'My Identification',
    orderNo: 'Order Number',
    detailedDrawing: 'Detailed Drawing',
    image: 'Image',
    brand: 'Brand',
    series: 'Series',
    authenticationType: 'Authentication Type',
    createdAt: 'Created At',
    accept: 'accept',
    status: 'status',
    real: 'real',
    fake: 'fake',
    unable: 'unable',
    processing: 'processing',
    complete: 'complete',
    acceptTitle: 'Accept Order',
    confirmAccept: 'Are you sure you accept this order?',
    acceptsuccess: 'Accept Successfully',
    acceptFailed: 'Accept Failed',
    invalidOrder: 'Invalid Order',
    orderStatus: 'Order Status',
    appraiser: 'Appraiser',
    identify: 'Identify',
    read: 'read',
    scrambling: 'In progress, Please wait',
    result: 'Identification result',
    isIssue: 'Whether issued',
    noOrder: 'New',
    orderReceived: 'Received',
    identificationDate: 'Identification At',
    orderList: 'Order List',
    myIdentifications: 'My Order'
  },
  /// 提示
  tooltip: {
    imagesSuggest: 'It is recommended to upload images in png format with a ratio of 1:1',
    cannotModify: 'Modification is not supported after saving',
    identifyState: 'It is used for the display and hiding of APP identification categories.',
    size: 'Please enter US size for shoe size'

  },
  /// 基础设置
  settings: {
    appSet: 'App Configuration',
    agreement: 'Agreement',
    userAgreementCN: 'User Agreement（CN）',
    privacyAgreementCN: 'Privacy Aggrement（CN）',
    authenticateCN: 'Authenticate Notice（CN）',
    aboutUsCN: 'About Us（CN）',
    userAgreementEN: 'User Agreement（EN）',
    privacyAgreementEN: 'Privacy Aggrement（EN）',
    authenticateEN: 'Authenticate Notice（EN）',
    aboutUsEN: 'About Us（EN）',
    contactEmail: 'Contact Email',
    setPrice: 'Identify Price'
  },
  // 鉴别结果
  identifyResult: {
    tableTitle: 'Identify Result',
    name: 'Points Name',
    identityImg: 'Partial False Area',
    userImg: 'User Pictures',
    falseArea: 'Fake Area',
    describe: 'Describe',
    isReplenish: 'Isreplenish',
    identify: 'Identification of information',
    informUser: 'Notify the user that the modification is successful, and notify the user to fill the picture!',
    editSuccess: 'Modify successfully！',
    editFail: 'Modification failed, please try again later!',
    pleaseSelect: 'Please select the identification result!',
    identifySuccess: 'Identification is successful!',
    identifyFail: 'Authentication failed, please try again later!',
    waitReplenish: 'Waiting for the user to fill the graph, do not support the operation!',
    replenishStatus: 'Added status',
    real: 'real',
    fake: 'fake',
    unable: 'unable'
  },
  // 鉴定价格
  identifyPrice: {
    pageTitle: 'Identification of the price',
    tableTitle: 'The price set',
    name: 'Category',
    nameEn: 'Category',
    AI: 'AI',
    standard: 'Standard',
    topspeed: 'Topspeed'
  },
  feedback: { // 意见反馈
    pageTitle: 'Feedback',
    tableTitle: 'Feedback List',
    user: 'User',
    email: 'Email',
    image: 'Image',
    reply: 'Reply',
    maxSix: 'No more than 6 sheets',
    describe: 'Describe',
    createdAt: 'Created At',
    logout: 'User is logged out',
    replied: 'replied',
    unanswered: 'unanswered',
    replySuccessfully: 'Reply Successfully',
    replyStatus: 'Reply Status',
    feedbackContent: 'Feedback Content',
    feedbackAt: 'Feedback At'
  }
}

export default en
